{
  "key": "kerbside-front",
  "title": "Kerbside front yard",
  "suburb": "Kerbside",
  "locationGroup": "backyards",
  "grassType": "buffalo",
  "cellM": 0.5,
  "w": 24,
  "h": 30,
  "rows": [
    "........................",
    "........................",
    "ebbbbppbbbbbbggggpppppgb",
    "eggggppbbbbbbggggpppppgb",
    "eggggppbbbbbbggggpppppgb",
    "ebbggppgbbbbgggggpppppgb",
    "ebbggppggbbggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppggggggggggpppppgb",
    "ebbggppgggggggggopppppgb",
    "pppppppppppppppppppppppp",
    "pppppppppppppppppppppppp",
    "pppppppppppppppppppppppp",
    "gggggggggggggggggpppppgg",
    "gggggggggggggggggpppppgg",
    "ggggoggggggggggggpppppgg",
    "gggggggggggggggggpppppgg",
    "gggggggggggggggggpppppgg",
    "gggggggggggggggggpppppgg",
    "pppppppppppppppppppppppp",
    "........................",
    "........................"
  ],
  "zoneRows": [
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "........................",
    "NNNNNNNNNNNNNNNNN.....NN",
    "NNNNNNNNNNNNNNNNN.....NN",
    "NNNNNNNNNNNNNNNNN.....NN",
    "NNNNNNNNNNNNNNNNN.....NN",
    "NNNNNNNNNNNNNNNNN.....NN",
    "NNNNNNNNNNNNNNNNN.....NN",
    "........................",
    "........................",
    "........................"
  ],
  "zones": [
    {"id":"nature-strip","rangeMm":[50,70]}
  ],
  "rangeMm": [40,60],
  "startLengthMm": [90,130],
  "props": [
    {"id":"letterbox-1","kind":"letterbox","x":8.25,"y":8.75,"w":0.4,"h":0.3,"solid":true},
    {"id":"gum-tree-1","kind":"gum-tree","x":2.25,"y":11.75,"r":0.4,"solid":true,"canopyR":3.2},
    {"id":"power-pit-1","kind":"power-pit","x":10.25,"y":12.75,"w":0.4,"h":0.4,"solid":false},
    {"id":"tap-1","kind":"tap","x":3.25,"y":1.25,"r":0.1,"solid":false}
  ],
  "spawn": {"x":9.5,"y":11.25,"heading":-1.5707963267948966},
  "utePark": {"x":9.5,"y":13.25,"heading":0},
  "weedFraction": 0.2,
  "leaves": {"count":[120,180],"areas":[{"x":0,"y":8.5,"w":6,"h":5},{"x":0,"y":5,"w":3.5,"h":3.5}]},
  "camera": {"fit":"contain","allowLandscape":false},
  "mutations": ["bin-night","magpie-season","sprinkler","bindii","heavy-leaves","ibis","lost-ball","hot-day"]
}
